import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomainUrlService} from '../../../application/config/domain-url.service';
import {Observable} from 'rxjs';
import {Dashboard} from '../model/dashboard';
import {WidgetDetail} from '../../widget/model/widget-detail';

@Injectable({
              providedIn: 'root'
            })
export class DashboardService {

  readonly WIDGET_URL = this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/v1/widget';

  constructor(private httpClient: HttpClient,
              private domainUrlService: DomainUrlService) {
  }

  public getDashboardWidgetStructure(): Observable<Dashboard> {
    return this.httpClient.get<Dashboard>(this.WIDGET_URL) as Observable<Dashboard>;
  }

  public saveWidgetOrders(dashboardId: number, widgets: (WidgetDetail | void)[]): Observable<boolean> {
    return this.httpClient.put(`${this.WIDGET_URL}/${dashboardId}`, widgets) as Observable<boolean>;
  }

  public reinitializeDashboard(dashboardId: number): Observable<Dashboard> {
    return this.httpClient.get<Dashboard>(`${this.WIDGET_URL}/${dashboardId}/reinitialization`) as Observable<Dashboard>;
  }

}
